export class StopIcon {
  public stopIcon: SVGElement;

  constructor() {
    this.stopIcon = this.createStopIcon();
  }

  private createStopIcon(): SVGElement {
    const stopIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    stopIcon.setAttributeNS(null, "id", "stopIcon");
    stopIcon.setAttributeNS(null, "x", "24px");
    stopIcon.setAttributeNS(null, "y", "24px");
    stopIcon.setAttributeNS(null, "viewBox", "0 -1 24 24");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup?.classList?.add("svgIcon");
    stopIcon?.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(null, "d", "M6 6h12v12H6z");
    svgGroup.appendChild(path1);

    return stopIcon;
  }
}
